module.exports = __webpack_public_path__ + "img/fuel.9ce3bb24.svg";